<template>
  <ion-page>
    <ion-content fullscreen="true" class="forgotflow">
      <main>
        <div class="w-full h-full min-h-screen bg-paper">
          <div
            class="flex flex-row justify-between items-center mx-5 pt-4 mb-[20px] z-10 md:w-[552px] md:mx-auto"
            :class="{ 'pt-[92px]': isIos() }"
          >
            <button
              type="button"
              class="flex flex-row gap-1 items-center cursor-pointer"
              @click="back"
            >
              <DsIcon name="chevron-left" size="sm" aria-label="Back" class="text-grey-800" />
              <div class="text-text-body-md font-medium text-grey-800 pl-[4px]">Back</div>
            </button>

            <div v-if="showSteps" class="text-text-body-md text-grey-60 font-medium">
              {{ currentStep > totalSteps ? totalSteps : currentStep }}
              of {{ totalSteps }}
            </div>
          </div>
          <slot class="flex-1 pb-16 lg:pb-0" test="test"> </slot>
        </div>
      </main>
    </ion-content>
  </ion-page>
</template>

<script>
import { Icon as DsIcon } from '@team-hogc/hogc-one-design-system';
import { isIosNativeOnly } from '@/utils/platform-check';
import { IonContent, IonPage } from '@ionic/vue';
import { TOTAL_STEPS } from '@/constants/register/stageConfig.js';

export default {
  name: 'NoAuthLayout',
  components: {
    DsIcon,
    IonPage,
    IonContent,
  },
  props: {
    currentStep: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {
    totalSteps() {
      return TOTAL_STEPS;
    },
    showSteps() {
      return this.currentStep && this.totalSteps;
    },
  },
  methods: {
    back() {
      this.$emit('back');
    },
    isIos() {
      return isIosNativeOnly();
    },
  },
};
</script>
